module.exports = __webpack_public_path__ + "static/media/instagram_id.d8ccb6bc.png";